import React from "react";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import MCSControlTextArea from "components/MCSControlTextArea";
import { FormHelper } from "_helpers/FormHelper";

const CancelSubsciptionFormControl = (props) => {
  const control = props.control;
  const updateFormData = props.updateFormData;

  return (
    <>
      <Form>
        <FormControl position="left" space="fifty">
          <MCSControlTextArea
            name="subscription.cancellationReason"
            control={control}
            handleChange={updateFormData}
            rows="3"
            autoResize
            maxCharacters="512"
            label="Cancellation Reason (up to 512 characters)"
            rules={{
              required: true,
              maxLength: 512,
              validate: {
                isEmpty: (v) =>
                  FormHelper.isStringBlank(v) ||
                  "The Cancellation Reason cannot be blank",
              },
            }}
          />
        </FormControl>
      </Form>
    </>
  );
};

export default CancelSubsciptionFormControl;
